module.exports = __webpack_public_path__ + "static/media/spa.e679d35b.jpg";